import { render } from "./ChurchLocaleBanner.vue?vue&type=template&id=7587c9c7&scoped=true"
import script from "./ChurchLocaleBanner.vue?vue&type=script&lang=js"
export * from "./ChurchLocaleBanner.vue?vue&type=script&lang=js"

import "./ChurchLocaleBanner.vue?vue&type=style&index=0&id=7587c9c7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7587c9c7"]])

export default __exports__